module.exports = __webpack_public_path__ + "static/media/pro_planet_yellow.979ff5ee.svg";